// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.diamondsMain {
  background-color: #07405E;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  overflow-y: auto;
  position: fixed;
  padding: 12px;
}
.diamondsMain .ant-tabs-nav div {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
}
.diamondsMain .ant-tabs-nav::before {
  border-bottom: 0px;
}
.diamondsMain .actionsContainer {
  width: 100%;
}
@media (min-width: 450px) {
  .diamondsMain .actionsContainer {
    width: 400px;
  }
}
.diamondsMain .eyeContainer {
  position: relative;
}
.diamondsMain .eyeContainer .eyeBlock {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  right: -60px;
  top: 60px;
}
.diamondsMain .eyeContainer .eyeBlock p {
  margin: 0;
  margin-top: 30px;
  font-style: normal;
  color: #FFFFFF;
  font-weight: 400;
  line-height: 140%;
  padding: 0px;
  opacity: 0.8;
}
.diamondsMain .eyeContainer .eyeBlock .eyeWatching {
  position: absolute;
  margin-left: 10px;
  background-position: center;
  border-radius: 50%;
}
.diamondsMain .diamondsContainer, .diamondsMain .diamondContainer {
  height: 85%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 97%;
  margin-top: 20px;
  height: 100dvh;
  padding: 10px;
}
@media (min-width: 450px) {
  .diamondsMain .diamondsContainer, .diamondsMain .diamondContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .diamondsMain .diamondsContainer, .diamondsMain .diamondContainer {
    height: 100%;
  }
}
.diamondsMain .diamondsContainer .clickText, .diamondsMain .diamondContainer .clickText {
  color: rgb(208, 208, 208);
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  padding: 0px;
  margin: 0px;
  opacity: 0.5;
}
.diamondsMain .diamondsContainer .diamondsBlock:first-child, .diamondsMain .diamondContainer .diamondsBlock:first-child {
  margin-top: 20px;
}
.diamondsMain .diamondsContainer .diamondsBlock, .diamondsMain .diamondContainer .diamondsBlock {
  display: flex;
  position: relative;
  width: 100%;
  border-radius: 10px;
  border: 1px solid #699BB6;
}
.diamondsMain .diamondsContainer .diamondsBlock .diamond, .diamondsMain .diamondContainer .diamondsBlock .diamond {
  background-repeat: no-repeat;
  background-position: center;
  width: 100px;
  height: 100px;
  z-index: 2;
  position: relative;
  background-size: 100% 100%;
}
.diamondsMain .diamondsContainer .diamondsBlock .diamondShadow, .diamondsMain .diamondContainer .diamondsBlock .diamondShadow {
  animation: pulse 2s linear infinite;
  content: "";
  left: 5%;
  width: 60px;
  height: 60px;
  position: absolute;
  z-index: -1;
  border-radius: 50%;
  background: linear-gradient(90deg, #5f8e8b 0%, rgb(0, 134, 244) 35%);
  filter: blur(8px);
}
.diamondsMain .diamondsContainer .diamondsBlock .diamondHeading, .diamondsMain .diamondContainer .diamondsBlock .diamondHeading {
  padding: 0px 10px 10px;
}
.diamondsMain .diamondsContainer .diamondsBlock .diamondHeading h1, .diamondsMain .diamondContainer .diamondsBlock .diamondHeading h1 {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  margin: 10px 0px 5px 0px;
}
.diamondsMain .diamondsContainer .diamondsBlock .diamondHeading p, .diamondsMain .diamondContainer .diamondsBlock .diamondHeading p {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  padding: 0px;
  margin: 0px;
  opacity: 0.5;
}
.diamondsMain .diamondsContainer .active, .diamondsMain .diamondContainer .active {
  border: 2px solid rgb(149, 179, 202);
}
.diamondsMain .diamondsContainer .active h1, .diamondsMain .diamondContainer .active h1 {
  color: #FFFFFF !important;
}
.diamondsMain .diamondsContainer .active p, .diamondsMain .diamondContainer .active p {
  color: #FFFFFF;
  opacity: 1 !important;
}
.diamondsMain .diamondsContainer .ready, .diamondsMain .diamondContainer .ready {
  border: 2px solid rgb(40, 181, 35);
}

@keyframes pulse {
  0% {
    -webkit-transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.3);
  }
  100% {
    -webkit-transform: scale(1);
  }
}
@keyframes appear {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/diamonds/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AADJ;AAGQ;EACI,cCdK;EDeL,iCEXH;EFYG,eAAA;AADZ;AAII;EACI,kBAAA;AAFR;AAII;EAII,WAAA;AALR;AAEQ;EADJ;IAEQ,YAAA;EACV;AACF;AAEI;EACI,kBAAA;AAAR;AAEQ;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,SAAA;AADT;AAES;EACI,SAAA;EACF,gBAAA;EACA,kBAAA;EACA,cC5CE;ED6CF,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AAAX;AAES;EACI,kBAAA;EACD,iBAAA;EACC,2BAAA;EACA,kBAAA;AAAb;AAMI;EAII,WAAA;EAIA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AAVR;AAHQ;EADJ;IAEQ,YAAA;EAMV;AACF;AAJQ;EALJ;IAMQ,YAAA;EAOV;AACF;AACQ;EACI,yBAAA;EACA,iCExEH;EFyEG,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AACZ;AACQ;EACI,gBAAA;AACZ;AACQ;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AACZ;AAAY;EACI,4BAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,0BAAA;AAEhB;AAEY;EACI,mCAAA;EACA,WAAA;EAEA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,oEAAA;EACA,iBAAA;AADhB;AAGY;EACI,sBAAA;AADhB;AAEgB;EACA,cCzHC;ED0HD,iCEtHP;EFuHO,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAAhB;AAEgB;EACA,cClIC;EDmID,iCE/HP;EFgIO,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAAhB;AAIQ;EACI,oCAAA;AAFZ;AAGY;EACI,yBAAA;AADhB;AAIY;EACI,cCtJH;EDuJG,qBAAA;AAFhB;AAMQ;EACI,kCAAA;AAJZ;;AAWA;EACI;IACE,2BAAA;EARJ;EAWE;IACE,6BAAA;EATJ;EAYE;IACE,2BAAA;EAVJ;AACF;AAeA;EACI;IACI,UAAA;EAbN;EAeE;IACI,YAAA;EAbN;EAgBE;IACI,UAAA;EAdN;AACF","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/fonts.scss';\n\n.diamondsMain {\n    background-color: #07405E;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    overflow-y: auto;\n    position: fixed;\n    padding: 12px;\n    .ant-tabs-nav{\n        div{\n            color: $color-Secondary ;\n            font-family: $Roboto;\n            font-size: 18px;\n        }\n    }\n    .ant-tabs-nav::before{\n        border-bottom: 0px;\n    }\n    .actionsContainer{\n        @media (min-width: 450px){\n            width: 400px;\n        }\n        width: 100%;\n    }\n    .eyeContainer{\n        position: relative;\n\n        .eyeBlock{\n         display: flex;\n         flex-direction: column;\n         position: absolute;\n         \n         width: 100%;\n         right:-60px;\n         top:60px;\n         p{\n             margin:0;\n           margin-top: 30px;\n           font-style: normal;\n           color: $color-White;\n           font-weight: 400;\n           line-height: 140%;\n           padding: 0px;\n           opacity: 0.8;\n         }\n         .eyeWatching{\n             position: absolute;\n            margin-left: 10px;\n             background-position: center;\n             border-radius: 50%;\n           \n         }\n        }\n    }\n\n    .diamondsContainer , .diamondContainer{\n        @media (min-width: 450px){\n            width: 400px;\n        }\n        height: 85%;\n        @media only screen and (max-height: 712px) {\n            height: 100%;\n        }\n        display: flex;\n        align-items: flex-start;\n        flex-direction: column;\n        width: 97%;\n        margin-top: 20px;\n        height: 100dvh;\n        padding: 10px;\n        .clickText{ \n            color: rgb(208, 208, 208);\n            font-family: $Roboto;\n            font-size: 18px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 140%;\n            padding: 0px;\n            margin: 0px;\n            opacity: 0.5;\n        }\n        .diamondsBlock:first-child {\n            margin-top: 20px;\n        }\n        .diamondsBlock{\n            display: flex;\n            position: relative;\n            width: 100%;\n            border-radius: 10px;\n            border: 1px solid $color-Secondary;\n            .diamond{\n                background-repeat: no-repeat;\n                background-position: center;\n                width: 100px;\n                height: 100px;\n                z-index: 2;\n                position: relative;\n                background-size: 100% 100%;\n\n            }\n          \n            .diamondShadow{\n                animation: pulse 2s linear infinite;\n                content: \"\";\n                // top: 18%;\n                left: 5%;\n                width: 60px;\n                height: 60px;\n                position: absolute;\n                z-index: -1;\n                border-radius: 50%;\n                background: linear-gradient(90deg,#5f8e8b 0%, rgb(0, 134, 244) 35%);\n                filter: blur(8px); \n            }\n            .diamondHeading  {\n                padding: 0px 10px 10px ;\n                h1 {\n                color: $color-Secondary;\n                font-family: $Roboto;\n                font-size: 20px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: 140%;\n                margin: 10px 0px 5px 0px;\n            }\n                p{ \n                color: $color-Secondary;\n                font-family: $Roboto;\n                font-size: 15px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 140%;\n                padding: 0px;\n                margin: 0px;\n                opacity: 0.5;\n            }\n            }\n        }\n        .active{\n            border: 2px solid rgb(149, 179, 202);\n            h1{\n                color: $color-White !important;\n\n            }\n            p{\n                color: $color-White;\n                opacity: 1 !important\n\n            }\n        }\n        .ready{\n            border: 2px solid rgb(40, 181, 35);\n        }\n        \n\n    }\n}\n\n@keyframes pulse {\n    0% {\n      -webkit-transform: scale(1)  ;\n    //   opacity: 0.2;\n    }\n    50% {\n      -webkit-transform: scale(1.3) ;\n    //   opacity: 1;\n    }\n    100% {\n      -webkit-transform: scale(1) ;\n    //   opacity: 0;\n    }\n}\n\n\n@keyframes appear {\n    0% {\n        opacity: 0;\n    }\n    50% {\n        opacity: 0.5;\n\n    }\n    100% {\n        opacity: 1;\n\n    }\n}\n\n","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
